import React, { createContext, useContext, useEffect, useState } from 'react';

const DeviceLayoutContext = createContext({ isLittle: false });

export const DeviceLayoutProvider = ({ children }) => {
  const [isLittle, setIsLittle] = useState(false);

  const checkLayout = () => {
    const ua = navigator.userAgent;
    const isMobileUA = /Mobi|Android|iPhone/i.test(ua);
    const isTabletUA =
      /Tablet|iPad/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    const isNarrow = window.innerWidth < 768;

    setIsLittle(isMobileUA || isTabletUA || isNarrow);
  };

  useEffect(() => {
    checkLayout();
    window.addEventListener('resize', checkLayout);
    return () => window.removeEventListener('resize', checkLayout);
  }, []);

  return (
    <DeviceLayoutContext.Provider value={{ isLittle }}>
      {children}
    </DeviceLayoutContext.Provider>
  );
};

export const useDeviceLayout = () => useContext(DeviceLayoutContext);
